/**
 * 路测工具相关接口路径
 *
 * 使用 createApiPaths 统一管理，业务代码和测试代码引用同一个路径常量。
 * - 业务代码：RoadTestPaths.GET_SCHEME_LIST.fullPath
 * - 测试 Mock：RoadTestPaths.GET_SCHEME_LIST.pattern
 */
import { createApiPaths } from '@jdx/testing-config/utils';

export const RoadTestPaths = createApiPaths('/monitor/web', {
  /** 获取车辆基础信息（用于判断 ownerUseCase） */
  GET_VEHICLE_BASIC_INFO: { path: '/basic/vehicle', method: 'POST', description: '获取车辆基础信息' },

  /** 根据车号及路测类型获取路测方案列表 */
  GET_ROAD_TEST_SCHEME_LIST: { path: '/roadtest/getTaskSchemeList', method: 'POST', description: '获取路测方案列表' },

  /** 创建路测任务 */
  CREATE_ROAD_TEST_TASK: { path: '/roadtest/createTask', method: 'POST', description: '创建路测任务' },

  /** 保存路测任务详情 */
  SAVE_ROAD_TEST_TASK_DETAIL: { path: '/roadtest/saveTaskDetail', method: 'POST', description: '保存路测任务详情' },

  /** 提交路测任务详情 */
  SUBMIT_ROAD_TEST_TASK_DETAIL: { path: '/roadtest/submitTaskDetail', method: 'POST', description: '提交路测任务详情' },

  /** 作废路测任务 */
  CANCEL_ROAD_TEST_TASK: { path: '/roadtest/cancelTask', method: 'POST', description: '作废路测任务' },

  /** 路测测评详情（轮询） */
  GET_ROAD_TEST_TASK_DETAIL: { path: '/roadtest/getRoadTaskDetail', method: 'POST', description: '路测测评详情' },

  /** 获取路测关注区测试项列表 */
  GET_ROAD_TEST_ATTENTION_ITEM_LIST: { path: '/roadtest/getItemList', method: 'POST', description: '获取关注区测试项列表' },

  /** 新增动态图层 */
  ADD_ROAD_TEST_DYNAMIC_LAYER: { path: '/roadtest/add_dynamic_layer', method: 'POST', description: '新增动态图层' },

  /** 整车回放 */
  GET_VEHICLE_REPLAY: { path: '/roadtest/getVehicleReplay', method: 'POST', description: '分段获取整车回放' },
});


